import {createEntityAdapter} from '@reduxjs/toolkit'
import { ITransaction } from '../../types'

export const transactionsAdapter = createEntityAdapter<ITransaction>()